module.exports = __webpack_public_path__ + "images/c742aae16b99208eee64c1a966696213.svg";